import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { PricelistVersion } from './product-pricelist-version';

export class ProductPricelist {
  id: number;
  name: string;
  pricelistVersions: PricelistVersion[] = [];

  constructor() { }

  static arrayFromJSON(json: string): ProductPricelist[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: ProductPricelist[] = [];
    for (const item of values) {
      result.push(ProductPricelist.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): ProductPricelist {
    if (object === null || object === undefined) {
      return null;
    }
    const productPricelist = new ProductPricelist();
    productPricelist.id = object.id;
    productPricelist.name = object.name;
    productPricelist.pricelistVersions = object.pricelistVersions ? object.pricelistVersions.map(x => PricelistVersion.createFromAny(x)) : new Array<PricelistVersion>();

    return productPricelist;
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      pricelistVersions: this.pricelistVersions,
    };
  }
}
